module.exports = __webpack_public_path__ + "img/main-slide-mobile-4.9d46086d.jpeg";